import { useState, useEffect, useRef } from 'react';

export const useSticky = () => {
  const [isSticky, setSticky] = useState(false);
  const element = useRef(null);
  const parentBlock = document.querySelector(".cp-react-app");
  const mobile = window.matchMedia("(max-width: 768px)");

  const handleScroll = () => {
    const scrollTop = window.pageYOffset;
    const parentTop = parentBlock.offsetTop;
    const parentBottom = parentTop + parentBlock.offsetHeight;
    
    if (scrollTop > parentTop && scrollTop < parentBottom - element.current.offsetHeight && !mobile.matches) {
      element.current.style.top = window.pageYOffset - parentTop + "px";
      setSticky(true);
    } else if (scrollTop <= parentTop) {
      element.current.style.top = "0";
      setSticky(false)
    } else if (mobile.matches) {
      element.current.style.top = "0";
      setSticky(false)
    } else {
      setSticky(false)
    }
  };

  // Add and clean up the scroll event listener
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  return { isSticky, element };
};